import { SystemFuncArgs } from '$legacyecstatic';
import CarnivoreDoc from 'editor/components/CarnivoreDoc';
import Zooming from 'editor/components/Zooming';
import { Components } from '../components';

export const updateZoomingComponents = [CarnivoreDoc, Zooming];

export function updateZooming(args: SystemFuncArgs<Components>): void {
  const { components } = args;
  const { doc } = components.get(CarnivoreDoc);
  const zoomingComp = components.get(Zooming);

  const [carnivoreCanvasScale] = doc.transform;

  const scaleHasNotChanged =
    Math.abs(carnivoreCanvasScale - zoomingComp.previousCanvasScale) <
    0.00000000001;

  if (scaleHasNotChanged) {
    const countIsBelowCap =
      zoomingComp.scaleOccurenceCount < zoomingComp.scaleOccurenceThreshold + 1;

    if (countIsBelowCap) {
      zoomingComp.scaleOccurenceCount++;
    }
  } else {
    zoomingComp.scaleOccurenceCount = 0;
  }

  zoomingComp.previousCanvasScale = carnivoreCanvasScale;
}
